import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionService } from '../services/permission.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReportsGuard implements CanActivate {

  constructor( private permissionService: PermissionService, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.permissionService.permissions$.pipe(
      map( permissions => {
        const canViewReports = permissions.canViewReports;
        if (!canViewReports) {
          return this.router.parseUrl('loan-images');
        }
        return true;
      }),
    );
  }
}
